import type { Ref } from "react";

/** Selector de archivo del formulario público (botón grande + nombre del
 * archivo elegido). Vivía dentro de PublicTournamentRegistrationPage. */
export default function FileUploadControl({
  id,
  accept,
  file,
  onChange,
  inputRef,
}: {
  id: string;
  accept: string;
  file: File | null | undefined;
  onChange: (file: File | null) => void;
  inputRef?: Ref<HTMLInputElement>;
}) {
  return (
    <div className="public-registration-file-control">
      <input
        id={id}
        ref={inputRef}
        className="public-registration-file-control__input"
        type="file"
        accept={accept}
        onChange={(e) => onChange(e.target.files?.[0] ?? null)}
      />
      <label className="public-registration-file-control__button" htmlFor={id}>
        Seleccionar archivo
      </label>
      <span className={`public-registration-file-control__status${file ? " is-selected" : ""}`}>
        {file ? file.name : "Pendiente"}
      </span>
    </div>
  );
}
